import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';

const API_URL = process.env.REACT_APP_API_URL || '';

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '30px'
  },
  statCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    textAlign: 'center'
  },
  statValue: {
    fontSize: '32px',
    fontWeight: '700',
    marginBottom: '5px'
  },
  statLabel: {
    fontSize: '14px',
    color: '#666'
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    marginBottom: '20px'
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#333'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#555'
  },
  input: {
    padding: '12px 14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none'
  },
  textarea: {
    padding: '12px 14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    minHeight: '200px',
    resize: 'vertical',
    fontFamily: 'inherit'
  },
  select: {
    padding: '12px 14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none'
  },
  button: {
    padding: '14px 28px',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none'
  },
  primaryButton: {
    background: '#722F37',
    color: 'white'
  },
  secondaryButton: {
    background: '#28a745',
    color: 'white'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  th: {
    textAlign: 'left',
    padding: '12px 10px',
    borderBottom: '2px solid #f0f0f0',
    fontSize: '13px',
    fontWeight: '600',
    color: '#666'
  },
  td: {
    padding: '12px 10px',
    borderBottom: '1px solid #f0f0f0',
    fontSize: '14px'
  },
  badge: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500'
  },
  badgeSuccess: {
    background: '#d4edda',
    color: '#155724'
  },
  badgeError: {
    background: '#f8d7da',
    color: '#721c24'
  },
  badgePending: {
    background: '#fff3cd',
    color: '#856404'
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px',
    color: '#888'
  },
  linkBox: {
    background: '#f8f9fa',
    padding: '15px',
    borderRadius: '8px',
    marginTop: '15px',
    wordBreak: 'break-all',
    fontSize: '13px'
  },
  tabs: {
    display: 'flex',
    gap: '10px',
    marginBottom: '25px',
    flexWrap: 'wrap'
  },
  tab: {
    padding: '10px 20px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    background: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500'
  },
  tabActive: {
    borderColor: '#722F37',
    background: '#722F37',
    color: 'white'
  },
  checkboxList: {
    maxHeight: '200px',
    overflowY: 'auto',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    padding: '10px'
  },
  checkboxItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px',
    borderBottom: '1px solid #f0f0f0'
  }
};

const getDefaultEmailTemplate = (baseUrl) => `<div style="margin:0;padding:0;width:100%;background-color:#f2f0eb;">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#f2f0eb;">
    <tr>
      <td align="center" style="padding:0;">
        <table role="presentation" width="600" cellpadding="0" cellspacing="0" border="0" style="max-width:600px;width:100%;background-color:#f7f5f0;">

          <!-- HEADER: Logo -->
          <tr>
            <td align="center" style="padding:40px 30px 20px 30px;background-color:#f7f5f0;">
              <img src="${baseUrl}/email-assets/PLANTILLA_NL_EM_NEGRO.png" alt="Emilio Moro Bodegas" width="160" style="display:block;width:160px;height:auto;" />
            </td>
          </tr>

          <!-- TITLE -->
          <tr>
            <td align="center" style="padding:10px 40px 30px 40px;background-color:#f7f5f0;">
              <h1 style="margin:0;font-family:Georgia,'Times New Roman',serif;font-size:32px;font-weight:700;color:#2c2c2c;line-height:1.2;letter-spacing:0.5px;">
                Encuesta de Clima<br>Laboral 2025
              </h1>
            </td>
          </tr>

          <!-- BODY TEXT -->
          <tr>
            <td align="center" style="padding:0 45px 15px 45px;background-color:#f7f5f0;">
              <p style="margin:0;font-family:Georgia,'Times New Roman',serif;font-size:16px;line-height:1.7;color:#4a4a4a;text-align:center;">
                Estimado/a <strong>{{NOMBRE}}</strong>,
              </p>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:0 45px 15px 45px;background-color:#f7f5f0;">
              <p style="margin:0;font-family:Georgia,'Times New Roman',serif;font-size:16px;line-height:1.7;color:#4a4a4a;text-align:center;">
                Te invitamos a participar en la Encuesta de Clima Laboral 2025 de Bodegas Emilio Moro. Tu opini&oacute;n es muy importante para nosotros y nos ayudar&aacute; a seguir mejorando como equipo.
              </p>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:0 45px 15px 45px;background-color:#f7f5f0;">
              <p style="margin:0;font-family:Georgia,'Times New Roman',serif;font-size:16px;line-height:1.7;color:#4a4a4a;text-align:center;">
                La encuesta es completamente <strong>an&oacute;nima y confidencial</strong>. Solo te llevar&aacute; unos minutos completarla.
              </p>
            </td>
          </tr>

          <!-- CTA BUTTON -->
          <tr>
            <td align="center" style="padding:25px 30px 30px 30px;background-color:#f7f5f0;">
              <table role="presentation" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td align="center" style="background-color:#5C3D2E;border-radius:4px;">
                    <a href="{{LINK}}" target="_blank" style="display:inline-block;padding:16px 45px;font-family:Arial,Helvetica,sans-serif;font-size:13px;font-weight:700;color:#ffffff;text-decoration:none;letter-spacing:2px;text-transform:uppercase;">
                      COMENZAR ENCUESTA
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- FALLBACK LINK -->
          <tr>
            <td align="center" style="padding:0 45px 25px 45px;background-color:#f7f5f0;">
              <p style="margin:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;line-height:1.6;color:#999999;text-align:center;">
                Si el bot&oacute;n no funciona, copia y pega este enlace en tu navegador:<br>
                <a href="{{LINK}}" style="color:#5C3D2E;word-break:break-all;">{{LINK}}</a>
              </p>
            </td>
          </tr>

          <!-- SIGNATURE -->
          <tr>
            <td align="center" style="padding:15px 30px 30px 30px;background-color:#f7f5f0;">
              <img src="${baseUrl}/email-assets/PLANTILLA_NL_FIRMA-EM.png" alt="Emilio Moro" width="180" style="display:block;width:180px;height:auto;" />
            </td>
          </tr>

          <!-- FOOTER: Vineyard illustration -->
          <tr>
            <td align="center" style="padding:0;background-color:#f2f0eb;">
              <p style="margin:0;padding:30px 40px 20px 40px;font-family:Georgia,'Times New Roman',serif;font-size:20px;font-style:italic;font-weight:700;color:#3a3a3a;text-align:center;line-height:1.4;">
                Gracias por seguir formando<br>parte de nuestra historia
              </p>
            </td>
          </tr>

          <!-- WINE IN MODERATION -->
          <tr>
            <td align="center" style="padding:10px 30px 20px 30px;background-color:#f2f0eb;">
              <img src="${baseUrl}/email-assets/PLANTILLA_NL_WiM_Baseline-inside_Black.png" alt="Wine in Moderation" width="120" style="display:block;width:120px;height:auto;" />
            </td>
          </tr>

          <!-- FOOTER: Vineyard banner + logo -->
          <tr>
            <td align="center" style="padding:0;background-color:#f2f0eb;">
              <img src="${baseUrl}/email-assets/PLANTILLA_NL_VIÑEDO.png" alt="Viñedo Emilio Moro" width="600" style="display:block;width:100%;height:auto;" />
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</div>`;

function AdminNotifications() {
  const [activeTab, setActiveTab] = useState('send');
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [sendProgress, setSendProgress] = useState(null);

  const [emailSubject, setEmailSubject] = useState('Encuesta de Clima Laboral 2025 - Bodegas Emilio Moro');
  const [emailMessage, setEmailMessage] = useState('');

  const [linkQuantity, setLinkQuantity] = useState(10);
  const [linkType, setLinkType] = useState('empleado');
  const [generatedLinks, setGeneratedLinks] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  const [mailingStatus, setMailingStatus] = useState([]);
  const [mailingStats, setMailingStats] = useState({});
  const [statusFilter, setStatusFilter] = useState('all');

  const baseUrl = window.location.origin;

  useEffect(() => {
    if (!emailMessage) {
      setEmailMessage(getDefaultEmailTemplate(baseUrl));
    }
  }, [baseUrl, emailMessage]);

  const getPreviewHtml = () => {
    return emailMessage
      .replace(/\{\{NOMBRE\}\}/g, 'Juan García')
      .replace(/\{\{LINK\}\}/g, `${baseUrl}/encuesta/ejemplo-token-12345`);
  };

  const fetchData = async () => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      window.location.href = '/admin/login';
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const [empRes, notifRes, statusRes] = await Promise.all([
        fetch(`${API_URL}/api/admin/employees`, { headers }),
        fetch(`${API_URL}/api/admin/notifications`, { headers }),
        fetch(`${API_URL}/api/admin/mailing-status`, { headers })
      ]);

      if (empRes.status === 401 || notifRes.status === 401) {
        localStorage.removeItem('adminToken');
        window.location.href = '/admin/login';
        return;
      }

      const empData = await empRes.json();
      setEmployees(Array.isArray(empData) ? empData : []);
      const notifData = await notifRes.json();
      setNotifications(notifData.notifications || []);
      setStats(notifData.stats || {});

      if (statusRes.ok) {
        const statusData = await statusRes.json();
        setMailingStatus(statusData.employees || []);
        setMailingStats(statusData.stats || {});
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      setEmployees([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const activeEmployees = employees.filter(emp => emp.activo !== 0);
  const inactiveCount = employees.length - activeEmployees.length;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedEmployees(activeEmployees.map(emp => emp.id));
    } else {
      setSelectedEmployees([]);
    }
  };

  const handleSelectEmployee = (id) => {
    setSelectedEmployees(prev =>
      prev.includes(id)
        ? prev.filter(i => i !== id)
        : [...prev, id]
    );
  };

  // Polling del progreso de envío
  useEffect(() => {
    if (!sendProgress || !sendProgress.active) return;
    const token = localStorage.getItem('adminToken');
    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${API_URL}/api/admin/send-emails/progress`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setSendProgress(data);
        if (!data.active) {
          clearInterval(interval);
          setSending(false);
          fetchData();
        }
      } catch (err) {
        console.error('Error polling progress:', err);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [sendProgress?.active, sendProgress?.jobId]); // eslint-disable-line

  const handleSendEmails = async () => {
    if (selectedEmployees.length === 0) {
      alert('Selecciona al menos un empleado');
      return;
    }

    if (!window.confirm(`¿Enviar email a ${selectedEmployees.length} empleados?\n\nEl envío se hará de forma gradual para evitar bloqueos del servidor de correo.`)) {
      return;
    }

    setSending(true);
    const token = localStorage.getItem('adminToken');

    try {
      const res = await fetch(`${API_URL}/api/admin/send-emails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          employeeIds: selectedEmployees,
          subject: emailSubject,
          message: emailMessage,
          baseUrl
        })
      });

      const data = await res.json();

      if (data.started) {
        setSendProgress({ active: true, jobId: data.jobId, total: data.total, sent: 0, failed: 0, errors: [], currentEmail: '' });
        setSelectedEmployees([]);
      } else if (data.error) {
        alert('Error: ' + data.error);
        setSending(false);
      }
    } catch (err) {
      alert('Error al iniciar el envío');
      setSending(false);
    }
  };

  const handleCancelSend = async () => {
    if (!window.confirm('¿Cancelar el envío en curso? Los emails ya enviados no se pueden deshacer.')) return;
    const token = localStorage.getItem('adminToken');
    try {
      await fetch(`${API_URL}/api/admin/send-emails/cancel`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (err) {
      console.error('Error cancelling:', err);
    }
  };

  const handleGenerateLinks = async () => {
    const token = localStorage.getItem('adminToken');

    try {
      const res = await fetch(`${API_URL}/api/admin/generate-links`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          cantidad: linkQuantity,
          tipoEncuesta: linkType
        })
      });

      const data = await res.json();
      setGeneratedLinks(data.links.map(token => `${baseUrl}/encuesta/${token}`));
    } catch (err) {
      alert('Error al generar enlaces');
    }
  };

  const copyLinks = () => {
    navigator.clipboard.writeText(generatedLinks.join('\n'));
    alert('Enlaces copiados al portapapeles');
  };

  return (
    <AdminLayout title="Notificaciones y Envíos">
      <div style={styles.grid}>
        <div style={styles.statCard}>
          <div style={{ ...styles.statValue, color: '#28a745' }}>{stats.enviados || 0}</div>
          <div style={styles.statLabel}>Emails Enviados</div>
        </div>
        <div style={styles.statCard}>
          <div style={{ ...styles.statValue, color: '#ffc107' }}>{stats.pendientes || 0}</div>
          <div style={styles.statLabel}>Pendientes</div>
        </div>
        <div style={styles.statCard}>
          <div style={{ ...styles.statValue, color: '#dc3545' }}>{stats.errores || 0}</div>
          <div style={styles.statLabel}>Errores</div>
        </div>
      </div>

      <div style={styles.tabs}>
        <button
          style={{ ...styles.tab, ...(activeTab === 'send' ? styles.tabActive : {}) }}
          onClick={() => setActiveTab('send')}
        >
          Enviar Emails
        </button>
        <button
          style={{ ...styles.tab, ...(activeTab === 'links' ? styles.tabActive : {}) }}
          onClick={() => setActiveTab('links')}
        >
          Generar Enlaces
        </button>
        <button
          style={{ ...styles.tab, ...(activeTab === 'status' ? styles.tabActive : {}) }}
          onClick={() => setActiveTab('status')}
        >
          Estado de Envíos
        </button>
        <button
          style={{ ...styles.tab, ...(activeTab === 'history' ? styles.tabActive : {}) }}
          onClick={() => setActiveTab('history')}
        >
          Historial
        </button>
      </div>

      {activeTab === 'send' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '20px' }}>
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>Seleccionar Destinatarios</h3>

            <div style={styles.checkboxItem}>
              <input
                type="checkbox"
                checked={selectedEmployees.length === activeEmployees.length && activeEmployees.length > 0}
                onChange={handleSelectAll}
              />
              <strong>Seleccionar todos ({activeEmployees.length} activos)</strong>
            </div>

            {inactiveCount > 0 && (
              <div style={{ padding: '8px 10px', fontSize: '12px', color: '#856404', background: '#fff3cd', borderRadius: '4px', margin: '5px 0' }}>
                {inactiveCount} empleado(s) inactivo(s) excluido(s) del envío
              </div>
            )}

            <div style={styles.checkboxList}>
              {activeEmployees.map(emp => (
                <div key={emp.id} style={styles.checkboxItem}>
                  <input
                    type="checkbox"
                    checked={selectedEmployees.includes(emp.id)}
                    onChange={() => handleSelectEmployee(emp.id)}
                  />
                  <div>
                    <div>{emp.email}</div>
                    <div style={{ fontSize: '12px', color: '#888' }}>
                      {emp.nombre} - {emp.departamento || 'Sin departamento'}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: '15px', fontSize: '14px', color: '#666' }}>
              {selectedEmployees.length} empleados seleccionados
            </div>
          </div>

          <div style={styles.card}>
            <h3 style={styles.cardTitle}>Contenido del Email</h3>
            <div style={styles.form}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Asunto</label>
                <input
                  type="text"
                  style={styles.input}
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                />
              </div>
              <div style={styles.inputGroup}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <label style={styles.label}>
                    Cuerpo del email (HTML) - Variables: {"{{NOMBRE}}"} y {"{{LINK}}"}
                  </label>
                  <button
                    type="button"
                    onClick={() => setShowPreview(!showPreview)}
                    style={{
                      background: showPreview ? '#722F37' : '#f0f0f0',
                      color: showPreview ? 'white' : '#333',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: '500'
                    }}
                  >
                    {showPreview ? '✓ Vista previa' : 'Ver vista previa'}
                  </button>
                </div>

                {showPreview ? (
                  <div style={{
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '20px',
                    background: '#f9f9f9',
                    minHeight: '400px',
                    overflow: 'auto'
                  }}>
                    <div style={{
                      background: 'white',
                      padding: '20px',
                      borderRadius: '8px',
                      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                    }}>
                      <div style={{ marginBottom: '15px', padding: '10px', background: '#f5f5f5', borderRadius: '4px' }}>
                        <strong>De:</strong> RRHH - Bodegas Emilio Moro &lt;rrhh@emiliomoro.com&gt;<br/>
                        <strong>Para:</strong> juan.garcia@ejemplo.com<br/>
                        <strong>Asunto:</strong> {emailSubject}
                      </div>
                      <div dangerouslySetInnerHTML={{ __html: getPreviewHtml() }} />
                    </div>
                  </div>
                ) : (
                  <textarea
                    style={{ ...styles.textarea, minHeight: '400px', fontFamily: 'monospace', fontSize: '13px' }}
                    value={emailMessage}
                    onChange={(e) => setEmailMessage(e.target.value)}
                  />
                )}

                <div style={{ marginTop: '10px', fontSize: '12px', color: '#888' }}>
                  <strong>Variables disponibles:</strong> {"{{NOMBRE}}"} = nombre del empleado, {"{{LINK}}"} = enlace único a la encuesta
                </div>
              </div>
              {!sendProgress?.active && (
                <button
                  style={{
                    ...styles.button,
                    ...styles.primaryButton,
                    opacity: sending ? 0.7 : 1
                  }}
                  onClick={handleSendEmails}
                  disabled={sending}
                >
                  {sending && !sendProgress?.active ? 'Iniciando...' : `Enviar a ${selectedEmployees.length} empleados`}
                </button>
              )}

              {sendProgress && (
                <div style={{
                  marginTop: '15px',
                  padding: '20px',
                  background: sendProgress.active ? '#f0f8ff' : (sendProgress.failed > 0 ? '#fff5f5' : '#f0fff0'),
                  borderRadius: '8px',
                  border: `1px solid ${sendProgress.active ? '#b3d9f2' : (sendProgress.failed > 0 ? '#f5c6cb' : '#c3e6cb')}`
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <strong style={{ fontSize: '15px' }}>
                      {sendProgress.active ? 'Enviando emails...' : 'Envío completado'}
                    </strong>
                    <span style={{ fontSize: '14px', color: '#666' }}>
                      {sendProgress.sent + sendProgress.failed} / {sendProgress.total}
                    </span>
                  </div>

                  {/* Barra de progreso */}
                  <div style={{ background: '#e0e0e0', borderRadius: '10px', height: '12px', overflow: 'hidden', marginBottom: '12px' }}>
                    <div style={{
                      height: '100%',
                      borderRadius: '10px',
                      width: `${sendProgress.total > 0 ? ((sendProgress.sent + sendProgress.failed) / sendProgress.total * 100) : 0}%`,
                      background: sendProgress.active ? '#17a2b8' : (sendProgress.failed > 0 ? '#ffc107' : '#28a745'),
                      transition: 'width 0.5s ease'
                    }} />
                  </div>

                  <div style={{ display: 'flex', gap: '20px', fontSize: '13px', marginBottom: sendProgress.active ? '12px' : '0' }}>
                    <span style={{ color: '#28a745' }}>Enviados: {sendProgress.sent}</span>
                    <span style={{ color: '#dc3545' }}>Errores: {sendProgress.failed}</span>
                    {sendProgress.active && sendProgress.currentEmail && (
                      <span style={{ color: '#666' }}>Actual: {sendProgress.currentEmail}</span>
                    )}
                  </div>

                  {sendProgress.active && (
                    <button
                      style={{ ...styles.button, background: '#dc3545', color: 'white', padding: '8px 20px', fontSize: '13px' }}
                      onClick={handleCancelSend}
                    >
                      Cancelar envío
                    </button>
                  )}

                  {!sendProgress.active && sendProgress.errors.length > 0 && (
                    <div style={{ marginTop: '10px', maxHeight: '120px', overflowY: 'auto', fontSize: '12px' }}>
                      <strong>Errores:</strong>
                      {sendProgress.errors.map((e, i) => (
                        <div key={i} style={{ color: '#dc3545', padding: '2px 0' }}>{e.email}: {e.error}</div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {activeTab === 'links' && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Generar Enlaces Directos</h3>
          <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
            Genera enlaces únicos para distribuir manualmente (sin envío de email).
          </p>

          <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '20px' }}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Cantidad</label>
              <input
                type="number"
                style={{ ...styles.input, width: '100px' }}
                value={linkQuantity}
                onChange={(e) => setLinkQuantity(parseInt(e.target.value) || 1)}
                min="1"
                max="100"
              />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Tipo de encuesta</label>
              <select
                style={styles.select}
                value={linkType}
                onChange={(e) => setLinkType(e.target.value)}
              >
                <option value="empleado">Empleado</option>
                <option value="directivo">Directivo</option>
              </select>
            </div>
          </div>

          <button
            style={{ ...styles.button, ...styles.secondaryButton }}
            onClick={handleGenerateLinks}
          >
            Generar Enlaces
          </button>

          {generatedLinks.length > 0 && (
            <>
              <div style={styles.linkBox}>
                {generatedLinks.map((link, idx) => (
                  <div key={idx} style={{ marginBottom: '5px' }}>{link}</div>
                ))}
              </div>
              <button
                style={{ ...styles.button, ...styles.primaryButton, marginTop: '15px' }}
                onClick={copyLinks}
              >
                Copiar todos los enlaces
              </button>
            </>
          )}
        </div>
      )}

      {activeTab === 'status' && (
        <div>
          <div style={{ ...styles.grid, gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' }}>
            <div style={styles.statCard}>
              <div style={{ ...styles.statValue, color: '#333', fontSize: '28px' }}>{mailingStats.total || 0}</div>
              <div style={styles.statLabel}>Total</div>
            </div>
            <div style={styles.statCard}>
              <div style={{ ...styles.statValue, color: '#17a2b8', fontSize: '28px' }}>{mailingStats.email_enviado || 0}</div>
              <div style={styles.statLabel}>Email Enviado</div>
            </div>
            <div style={styles.statCard}>
              <div style={{ ...styles.statValue, color: '#28a745', fontSize: '28px' }}>{mailingStats.completadas || 0}</div>
              <div style={styles.statLabel}>Completadas</div>
            </div>
            <div style={styles.statCard}>
              <div style={{ ...styles.statValue, color: '#ffc107', fontSize: '28px' }}>{mailingStats.pendientes || 0}</div>
              <div style={styles.statLabel}>Pendientes</div>
            </div>
            <div style={styles.statCard}>
              <div style={{ ...styles.statValue, color: '#6c757d', fontSize: '28px' }}>{mailingStats.no_enviadas || 0}</div>
              <div style={styles.statLabel}>No Enviadas</div>
            </div>
          </div>

          <div style={styles.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
              <h3 style={{ ...styles.cardTitle, marginBottom: 0 }}>Seguimiento de Empleados</h3>
              <select
                style={styles.select}
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">Todos</option>
                <option value="completada">Encuesta completada</option>
                <option value="pendiente">Email enviado, pendiente</option>
                <option value="no_enviada">No enviada</option>
              </select>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Nombre</th>
                    <th style={styles.th}>Email</th>
                    <th style={styles.th}>Departamento</th>
                    <th style={styles.th}>Email Enviado</th>
                    <th style={styles.th}>Encuesta</th>
                    <th style={styles.th}>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {mailingStatus
                    .filter(emp => {
                      if (statusFilter === 'completada') return emp.encuesta_completada;
                      if (statusFilter === 'pendiente') return emp.email_enviado && !emp.encuesta_completada;
                      if (statusFilter === 'no_enviada') return !emp.email_enviado;
                      return true;
                    })
                    .map(emp => (
                      <tr key={emp.id} style={emp.activo ? {} : { opacity: 0.5 }}>
                        <td style={styles.td}>{emp.nombre || '-'}</td>
                        <td style={styles.td}>{emp.email}</td>
                        <td style={styles.td}>{emp.departamento || '-'}</td>
                        <td style={styles.td}>
                          <span style={{
                            ...styles.badge,
                            ...(emp.email_enviado ? styles.badgeSuccess : { background: '#e9ecef', color: '#6c757d' })
                          }}>
                            {emp.email_enviado ? 'Enviado' : 'No enviado'}
                          </span>
                        </td>
                        <td style={styles.td}>
                          <span style={{
                            ...styles.badge,
                            ...(emp.encuesta_completada
                              ? styles.badgeSuccess
                              : emp.email_enviado
                                ? styles.badgePending
                                : { background: '#e9ecef', color: '#6c757d' })
                          }}>
                            {emp.encuesta_completada ? 'Completada' : emp.email_enviado ? 'Pendiente' : '-'}
                          </span>
                        </td>
                        <td style={styles.td}>
                          {emp.fecha_completado
                            ? new Date(emp.fecha_completado).toLocaleString('es-ES')
                            : emp.fecha_envio
                              ? new Date(emp.fecha_envio).toLocaleString('es-ES')
                              : '-'}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'history' && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Historial de Envíos</h3>

          {loading ? (
            <div style={styles.emptyState}>Cargando...</div>
          ) : notifications.length === 0 ? (
            <div style={styles.emptyState}>No hay notificaciones enviadas</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Email</th>
                    <th style={styles.th}>Nombre</th>
                    <th style={styles.th}>Estado</th>
                    <th style={styles.th}>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((notif, idx) => (
                    <tr key={idx}>
                      <td style={styles.td}>{notif.email}</td>
                      <td style={styles.td}>{notif.nombre || '-'}</td>
                      <td style={styles.td}>
                        <span style={{
                          ...styles.badge,
                          ...(notif.email_enviado ? styles.badgeSuccess : styles.badgeError)
                        }}>
                          {notif.email_enviado ? 'Enviado' : 'Error'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        {notif.fecha_envio ? new Date(notif.fecha_envio).toLocaleString('es-ES') : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminNotifications;
